import React, { useState } from 'react';

// Lightbox para ver fotos en grande
function Lightbox({ src, onClose }) {
  return (
    <div style={{
      position: 'fixed', top: 0, left: 0, width: '100vw', height: '100vh',
      background: 'rgba(0,0,0,0.92)', zIndex: 10000, display: 'flex',
      alignItems: 'center', justifyContent: 'center', cursor: 'pointer',
      flexDirection: 'column'
    }} onClick={onClose}>
      <img src={src} alt="Foto" style={{
        maxWidth: '95vw', maxHeight: '85vh', borderRadius: 12,
        boxShadow: '0 20px 60px rgba(0,0,0,0.5)'
      }} />
      <p style={{ color: '#fff', marginTop: 16, fontSize: '0.85rem', opacity: 0.7 }}>
        Toca para cerrar
      </p>
    </div>
  );
}

// Miniaturas de fotos anexadas
function PhotoThumbs({ visita, onOpen }) {
  const fotos = [];
  if (visita.foto_placa_url) fotos.push({ url: visita.foto_placa_url, label: '🚗 Placa' });
  if (visita.foto_cedula_url) fotos.push({ url: visita.foto_cedula_url, label: '🪪 Cédula' });
  if (fotos.length === 0) return null;

  return (
    <div style={{ display: 'flex', gap: 8, marginTop: 8, flexWrap: 'wrap' }}>
      {fotos.map((f, i) => (
        <div key={i} onClick={(e) => { e.stopPropagation(); onOpen(f.url); }}
          style={{
            width: 64, height: 64, borderRadius: 8, overflow: 'hidden',
            cursor: 'pointer', border: '2px solid var(--border)',
            position: 'relative', flexShrink: 0
          }}>
          <img src={f.url} alt={f.label} style={{
            width: '100%', height: '100%', objectFit: 'cover'
          }} />
          <span style={{
            position: 'absolute', bottom: 0, left: 0, right: 0,
            background: 'rgba(0,0,0,0.6)', color: '#fff',
            fontSize: '0.6rem', textAlign: 'center', padding: '2px 0'
          }}>{f.label}</span>
        </div>
      ))}
    </div>
  );
}

// Modal para ver reporte
function ReportModal({ reports, onClose }) {
  const [lightboxSrc, setLightboxSrc] = useState(null);

  if (reports.length === 0) return null;

  return (
    <>
      {lightboxSrc && <Lightbox src={lightboxSrc} onClose={() => setLightboxSrc(null)} />}
      <div style={{
        position: 'fixed', top: 0, left: 0, width: '100vw', height: '100vh',
        background: 'rgba(0,0,0,0.7)', zIndex: 10001, display: 'flex',
        alignItems: 'center', justifyContent: 'center', padding: 20
      }} onClick={onClose}>
        <div className="card" style={{ maxWidth: 520, width: '100%', maxHeight: '85vh', overflow: 'auto' }}
          onClick={(e) => e.stopPropagation()}>
          <div className="card-header" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <h2>🚩 Reporte{reports.length > 1 ? 's' : ''} de Anomalía</h2>
            <button className="btn btn-ghost btn-sm" onClick={onClose}>✕ Cerrar</button>
          </div>
          {reports.map((r, idx) => (
            <div key={r.id || idx} style={{
              background: 'rgba(239,68,68,0.04)', borderRadius: 'var(--radius-sm)',
              padding: 16, marginBottom: idx < reports.length - 1 ? 12 : 0,
              border: '1px solid rgba(239,68,68,0.15)'
            }}>
              <div className="visit-detail">
                <span>🛡️ <strong>{r.vigilante_nombre || 'Vigilante'}</strong></span>
                <span>📅 {r.createdAt?.toDate ? new Date(r.createdAt.toDate()).toLocaleString('es-CO') : ''}</span>
              </div>
              {r.texto && (
                <div style={{ margin: '10px 0', padding: 12, background: 'rgba(255,255,255,0.6)', borderRadius: 8, fontSize: '0.88rem', lineHeight: 1.5, whiteSpace: 'pre-wrap' }}>
                  📝 {r.texto}
                </div>
              )}
              {r.fotos && r.fotos.length > 0 && (
                <div style={{ display: 'flex', gap: 8, marginTop: 10, flexWrap: 'wrap' }}>
                  {r.fotos.map((f, i) => (
                    <div key={i} onClick={() => setLightboxSrc(f)}
                      style={{
                        width: 80, height: 80, borderRadius: 8, overflow: 'hidden',
                        cursor: 'pointer', border: '2px solid var(--border)',
                        position: 'relative', flexShrink: 0
                      }}>
                      <img src={f} alt={`Evidencia ${i + 1}`} style={{
                        width: '100%', height: '100%', objectFit: 'cover'
                      }} />
                      <span style={{
                        position: 'absolute', bottom: 0, left: 0, right: 0,
                        background: 'rgba(0,0,0,0.6)', color: '#fff',
                        fontSize: '0.55rem', textAlign: 'center', padding: '2px 0'
                      }}>📸 Evidencia</span>
                    </div>
                  ))}
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </>
  );
}

export default function VisitItem({ visita, showReport, onReport, reports = [] }) {
  const [lightboxSrc, setLightboxSrc] = useState(null);
  const [showReportModal, setShowReportModal] = useState(false);
  const visitantes = visita.visitantes || [{ nombre: visita.visitante_nombre, cedula: visita.visitante_cedula }];
  const placas = visita.placas || (visita.placa_vehiculo ? [visita.placa_vehiculo] : []);
  const fecha = visita.escaneadoEn?.toDate
    ? new Date(visita.escaneadoEn.toDate()).toLocaleString('es-CO')
    : new Date(visita.escaneado_en).toLocaleString('es-CO');

  const hasReports = reports && reports.length > 0;

  return (
    <>
      {lightboxSrc && <Lightbox src={lightboxSrc} onClose={() => setLightboxSrc(null)} />}
      {showReportModal && <ReportModal reports={reports} onClose={() => setShowReportModal(false)} />}
      <div className="history-item" style={hasReports ? {
        borderLeftColor: 'var(--danger)',
        background: 'linear-gradient(135deg, rgba(239,68,68,0.04), rgba(255,255,255,0.7))',
        animation: 'pulseWarning 2s ease-in-out infinite'
      } : {}}>
        <div className="visit-header">
          <div className="visit-name">
            {visitantes.length === 1 ? visitantes[0].nombre : `${visitantes.length} visitantes`}
          </div>
          <div style={{ display: 'flex', gap: 8, alignItems: 'center' }}>
            {hasReports ? (
              <button
                onClick={(e) => { e.stopPropagation(); setShowReportModal(true); }}
                style={{
                  background: 'linear-gradient(135deg, #ef4444, #dc2626)',
                  color: '#fff', border: 'none', borderRadius: 20,
                  padding: '5px 14px', fontSize: '0.78rem', fontWeight: 700,
                  cursor: 'pointer', display: 'flex', alignItems: 'center', gap: 5,
                  boxShadow: '0 2px 12px rgba(239,68,68,0.5)',
                  animation: 'pulseGlow 1.5s ease-in-out infinite'
                }}>
                🚩 {reports.length > 1 ? `${reports.length} ` : ''}REPORTE{reports.length > 1 ? 'S' : ''}
              </button>
            ) : (
              <span className="badge badge-success">Registrada</span>
            )}
            {showReport && (
              <button className="btn btn-ghost btn-sm" onClick={(e) => { e.stopPropagation(); onReport(visita); }}
                style={{ color: 'var(--danger)', fontSize: '0.75rem' }}>
                🚩 Reportar
              </button>
            )}
          </div>
        </div>
        <div className="visit-detail">
          {visitantes.map((vis, i) => (
            <span key={i}>👤 {vis.nombre} · 🪪 {vis.cedula}</span>
          ))}
        </div>
        <div className="visit-detail">
          <span>🏠 Apto {visita.apartamento} P{visita.piso} — {visita.residente_nombre}</span>
        </div>
        <div className="visit-detail">
          <span>📋 {visita.motivo}</span>
          {placas.length > 0 && <span>🚗 {placas.join(', ')}</span>}
        </div>
        <div className="visit-detail">
          <span>🛡️ {visita.vigilante_nombre || 'Vigilante'}</span>
        </div>
        <PhotoThumbs visita={visita} onOpen={setLightboxSrc} />
        <div className="visit-date">📅 {fecha}</div>
      </div>
    </>
  );
}